export const root = state => state.getIn(['resources']);
export const resources = state => root(state).get('entities');
export const resourceById = (state, id) => resources(state).get(String(id));
export const resourcesByIds = (state, ids) => ids.map(id => resourceById(state, id));
